module.exports = __webpack_public_path__ + "static/media/plus.617faee7.svg";